import { render, staticRenderFns } from "./basetable.vue?vue&type=template&id=a660a982&scoped=true&"
import script from "./basetable.vue?vue&type=script&lang=js&"
export * from "./basetable.vue?vue&type=script&lang=js&"
import style0 from "./basetable.vue?vue&type=style&index=0&id=a660a982&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a660a982",
  null
  
)

export default component.exports